import { useMemo } from 'react';

import { EmailNotificationProps } from './EmailNotification.decl';

import { Grid, Spacer, Toggle, Typography } from '@aircall/tractor';
import { Select } from '@components/Select';
import { useTranslation } from 'react-i18next';

export function EmailNotificationSection({
  name,
  isOn,
  isUpdating,
  frequency,
  frequencyOptions,
  onActivationStatusChange,
  onFrequencyChange,
  'data-test': dataTest,
}: EmailNotificationProps) {
  const { t } = useTranslation();

  const options =
    useMemo(
      () =>
        frequencyOptions?.map((value) => ({
          value,
          label: t(`user_profile.notifications.email_notifications.frequency.options.${value}`),
        })),
      [frequencyOptions, t]
    ) ?? [];

  return (
    <Spacer direction='vertical' space='xxs' p='s' fluid data-test={dataTest}>
      <Typography data-test='email-notification-title'>
        {t(`user_profile.notifications.email_notifications.sections.${name}.title`)}
      </Typography>
      <Grid
        gridTemplateColumns='max-content auto'
        gridRowGap='s'
        gridColumnGap='s'
        alignItems='center'
      >
        <Toggle
          name={`${name}-toggle`}
          data-test={`${name}-toggle`}
          checked={isOn}
          onChange={(value) => !isUpdating && onActivationStatusChange(name, value)}
          size='small'
        />
        <Typography data-test='email-notification-description'>
          {t(`user_profile.notifications.email_notifications.sections.${name}.description`)}
        </Typography>
        {isOn && frequencyOptions && (
          <>
            <div />
            <Spacer direction='vertical' space='xxxs'>
              <Typography>
                {t('user_profile.notifications.email_notifications.frequency.label')}
              </Typography>
              <Select
                name={`${name}-frequency`}
                placeholder={t('user_profile.notifications.email_notifications.frequency.label')}
                value={frequency || undefined}
                options={options}
                onChange={(value) => onFrequencyChange(name, value as string)}
              />
            </Spacer>
          </>
        )}
      </Grid>
    </Spacer>
  );
}
